import {EImagePickerError} from './definitions';

export default {
  uploadImage: 'Загрузить с компьютера',
  uploadByUrl: 'Загрузить ссылку на файл',
  imageDimensions: '{{width}} x {{height}} px',
  imageInfo: '{{format}} image {{size}}',
  urlLabel: 'Url файла',
  loading: 'Секунду, загружаем изображение...',
  imageError: 'Ошибка загрузки изображения: {{error}}',
  invalidUrl: 'Неправильный формат URL',
  loadingByUrlError: 'Ошибка при загрузке по ссылке',
  errors: {
    [EImagePickerError.FORMAT]: 'неверный формат',
    [EImagePickerError.ACCEPT]: 'допустимый формат файла - {{formats}}',
    [EImagePickerError.SIZE]: 'максимальный размер файла - {{size}}',
    [EImagePickerError.DIMENSIONS]: 'минимальный размер изображения - {{width}}x{{height}}px',
  },
};
